import React, { useState } from 'react';

// Status is derived from Redmine time: any time logged this or last month -> Active,
// none -> Paused (see ProjectDataProvider#list). The hint explains that on hover.
// In the list TABLE the column header carries a legend instead, so the table passes
// showHint={false}; the grid cards and the show page (no column header) keep it.
const STATUS = {
  active: {
    label: 'Active', bg: '#E8F2EC', fg: '#1F6B41',
    hint: 'Active — time was logged in Redmine this or last month.'
  },
  paused: {
    label: 'Paused', bg: '#F2EEE6', fg: '#7E5C16',
    hint: 'Paused — no time logged in Redmine this or last month.'
  }
};

export default function StatusPill({ status, showHint = true }) {
  const meta = STATUS[status] || { label: 'Unknown', bg: '#F0EFE9', fg: '#6B6B68' };
  const [open, setOpen] = useState(false);
  const hint = showHint ? meta.hint : null;

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => hint && setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <span
        className="inline-flex items-center text-[11px] px-2 py-0.5 rounded-full"
        style={{ background: meta.bg, color: meta.fg, fontWeight: 500 }}
      >
        {meta.label}
      </span>
      {open && hint && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            left: 0,
            zIndex: 50,
            width: 230,
            background: '#1A1A1A',
            color: '#fff',
            fontSize: 11,
            fontWeight: 400,
            lineHeight: 1.45,
            padding: '7px 10px',
            borderRadius: 6,
            boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
            whiteSpace: 'normal',
            pointerEvents: 'none'
          }}
        >
          {hint}
        </span>
      )}
    </span>
  );
}
